var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcWcagTextMedium = function SvgIcWcagTextMedium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "16px",
    viewBox: "0 0 29 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-1780.000000, -21.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rozmiar-fontu",
    transform: "translate(1624.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.851252,18 L160.995967,14.7449857 L167.475057,14.7449857 L168.596878,18 L172.00813,18 L166.078504,2 L162.39252,2 L156.44,18 L159.851252,18 Z M166.605073,12.2922636 L161.843057,12.2922636 L164.224065,5.46131805 L166.605073,12.2922636 Z M180.318764,15.6848138 L180.318764,11.3295129 L184.6,11.3295129 L184.6,8.37249284 L180.318764,8.37249284 L180.318764,3.99426934 L177.205138,3.99426934 L177.205138,8.37249284 L172.923902,8.37249284 L172.923902,11.3295129 L177.205138,11.3295129 L177.205138,15.6848138 L180.318764,15.6848138 Z",
    id: "A+"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcWcagTextMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_wcag_text_medium.ffe33653.svg";
export { ForwardRef as ReactComponent };